import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from "./actionTypes";
import * as CommodityAction from "./actions";
import { CommodityService } from "./service";

@Injectable()
export class CommodityEffect {
  constructor(
    private action: Actions,
    private commodityService: CommodityService
  ) {}

  GetCommodityList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_COMMODITY_LIST),
      switchMap((data) => this.commodityService.getCommodityList()),
      map((data: Array<any>) => new CommodityAction.CommodityList(data))
    )
  );

  CommodityById = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_COMMODITY_BY_ID),
      switchMap((data: any) => this.commodityService.getCommodityById(data.payload)),
      map((data: Array<any>) => new CommodityAction.CommodityById(data))
    )
  );

  SearchCommodityByFields = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_COMMODITY_BY_FIELD),
      switchMap((data: any) => this.commodityService.searchCommodityByFields(data.payload)),
      map((data) => new CommodityAction.CommodityByFieldList(data))
    )
  );

  AddCommodity = createEffect(() =>
    this.action.pipe(
      ofType(type.ADD_COMMODITY),
      switchMap((data: any) => this.commodityService.addCommodity(data.payload)),
      map((resp) => new CommodityAction.AddCommodityResp(resp))
    )
  );

  UpdateCommodity = createEffect(() =>
    this.action.pipe(
      ofType(type.UPDATE_COMMODITY),
      switchMap((data: any) => this.commodityService.updateCommodity(data.payload)),
      map((resp) => new CommodityAction.UpdateCommodityResp(resp))
    )
  );

  DeleteCommodity = createEffect(() =>
    this.action.pipe(
      ofType(type.DELETE_COMMODITY),
      switchMap((data: any) => this.commodityService.deleteCommodity(data.payload)),
      map((resp) => new CommodityAction.DeleteCommodityResp(resp))
    )
  );

  GetCommodityLinkedToContract = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_COMMODITIES_LINKBY_CONTRACT_ID),
      switchMap((action: any) => this.commodityService.getCommoditiesLInkedToContract(action.payload)),
      map((data: Array<any>) => new CommodityAction.CommoditiesLinkByContractIdResp(data))
    )
  );

  GetCostTrackerContractsByCommodityId = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_COST_TRACKER_CONTRACTS_BY_COMMODITY_ID),
      switchMap((action: any) => this.commodityService.getCostTrackerContractsByCommodityId(action.payload)),
      map((data: Array<any>) => new CommodityAction.CostTrackerContractsByCommodityIdResponse(data))
    )
  );
}
